<div class="tooltip-pending-container" piTesting="my-profile-tooltip-pending">
    <abstract-icon
        class="pending-icon"
        [iconType]="IconType.Hourglass"
        [iconSize]="IconSize.Big_45"
    >
    </abstract-icon>
    <div class="tooltip-pending-content">
        <div class="pending-title color-neutral-900">
            {{ 'myProfileTooltip.pending.title' | translate }}
        </div>
        <div class="pending-already-completed color-neutral-700">
            {{ 'myProfileTooltip.pending.description' | translate }}
        </div>
        <div class="pending-restart-prompt color-neutral-900">
            {{ 'myProfileTooltip.pending.restartPrompt' | translate }}
        </div>
        <div>
            <button
                class="button button-transparent take-assessment-btn"
                (click)="openNewTab($event)"
            >
                {{
                    'myProfileTooltip.pending.takeAssessment.button' | translate
                }}
            </button>
        </div>
    </div>
</div>
